module.exports = __webpack_public_path__ + "static/media/icon-download.e3037a4b.svg";